import * as React from 'react';

interface DurationProps {
  readonly minutes: number;
}

export function DurationView(props: DurationProps) {
  return <span>{format(props.minutes)}</span>;
}

function format(minutes: number) {
  const hrs = Math.floor(minutes / 60);
  const mins = minutes - hrs * 60;
  return hrs > 0 ? `${hrs}h ${mins}m` : `${mins}m`;
}



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/components/widgets/duration-view.tsx